import { ADDRESS_COMPONENT_ELEMENT_ID } from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { COUNTRIES_GROUPED_OPTIONS } from '@dealstack/shared/lib/countries/countriesData';
import { Flex, Title } from '@mantine/core';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { Select, TextInput } from 'react-hook-form-mantine';

interface Props {
	disabled?: boolean;
	countryFieldName: string;
	cityFieldName: string;
	postCodeFieldName: string;
	streetFieldName: string;
	houseNumberFieldName: string;
	title?: string;
	dataTestId?: string;
}

const AddressInput = ({
	disabled,
	houseNumberFieldName,
	streetFieldName,
	cityFieldName,
	countryFieldName,
	postCodeFieldName,
	title,
	dataTestId,
}: Props) => {
	const tInvestor = useTranslationInvestor();
	const formContext = useFormContext();

	return (
		<Flex direction="column" gap="1rem" w="100%" data-testid={dataTestId}>
			<Title order={6}>
				{title ??
					tInvestor('investment.personal_details.personal_information_form.address')}
			</Title>

			<TextInput
				label={tInvestor(
					'investment.personal_details.personal_information_form.house_number'
				)}
				placeholder={tInvestor(
					'investment.personal_details.personal_information_form.house_number'
				)}
				control={formContext.control}
				name={houseNumberFieldName}
				size="md"
				disabled={disabled}
				data-testid={ADDRESS_COMPONENT_ELEMENT_ID.INVESTOR_ADDRESS_HOUSE_NUMBER}
			/>

			<TextInput
				label={tInvestor('investment.personal_details.personal_information_form.street')}
				placeholder={tInvestor(
					'investment.personal_details.personal_information_form.street'
				)}
				control={formContext.control}
				name={streetFieldName}
				size="md"
				disabled={disabled}
				data-testid={ADDRESS_COMPONENT_ELEMENT_ID.INVESTOR_ADDRESS_STREET}
			/>

			<TextInput
				label={tInvestor('investment.personal_details.personal_information_form.city')}
				placeholder={tInvestor(
					'investment.personal_details.personal_information_form.city'
				)}
				control={formContext.control}
				name={cityFieldName}
				size="md"
				disabled={disabled}
				data-testid={ADDRESS_COMPONENT_ELEMENT_ID.INVESTOR_ADDRESS_CITY}
			/>

			<Select
				name={countryFieldName}
				control={formContext.control}
				label={tInvestor('investment.personal_details.personal_information_form.country')}
				placeholder={tInvestor(
					'investment.personal_details.personal_information_form.country'
				)}
				data={COUNTRIES_GROUPED_OPTIONS}
				searchable
				size="md"
				disabled={disabled}
				data-testid={ADDRESS_COMPONENT_ELEMENT_ID.INVESTOR_ADDRESS_COUNTRY}
			/>

			<TextInput
				label={tInvestor(
					'investment.personal_details.personal_information_form.postal_code'
				)}
				placeholder={tInvestor(
					'investment.personal_details.personal_information_form.postal_code'
				)}
				control={formContext.control}
				name={postCodeFieldName}
				size="md"
				disabled={disabled}
				data-testid={ADDRESS_COMPONENT_ELEMENT_ID.INVESTOR_ADDRESS_POST_CODE}
			/>
		</Flex>
	);
};
const _AddressInputExport = memo(AddressInput);

export { _AddressInputExport as AddressInput };
